import { removeRegionFromPath } from 'lib/url/searchUrlUtils'
import { useLocation } from 'react-router'

function useIsHomepage() {
  const pathname = removeRegionFromPath(useLocation().pathname)
  return pathname === '/'
}

export default useIsHomepage
